<template>

    <div class="dash-badge" :class="badgeClasses" :title="title">

        <template v-if="percent !== null">
            <div class="dash-badge-icon">
                <i class="fa fa-percentage"></i>
                <template v-if="shouldShowReversePercentSign">
                    <i :class="percentReverseSignClass"></i>
                </template>
            </div>
            <div class="dash-badge-metric">
                <template v-if="isValidPercent">
                    {{ getFormattedPercent }}
                </template>
                <i v-else class="fas fa-infinity"></i>
            </div>
        </template>

        <template v-else-if="seconds !== null">
            <div class="dash-badge-icon">
                <i class="fa fa-clock-o"></i>
            </div>
            <div class="dash-badge-metric">
                {{ seconds | format_seconds_short }}
            </div>
        </template>

        <template v-else-if="quantity !== null">
            <div class="dash-badge-icon">
                <i class="fas fa-boxes"></i>
            </div>
            <div class="dash-badge-metric">
                {{ quantity }}
            </div>
        </template>

    </div>

</template>

<script>
    export default {

        props: {
            percent: {
                type: [Number, String],
                default: null,
            },
            percent_type: {
                type: String,
                default: 'default',
            },
            seconds: {
                type: Number,
                default: null,
            },
            quantity: {
                type: Number,
                default: null,
            },
            title: {
                type: String,
                default: '',
            },
        },

        computed: {
            isValidPercent() {
                return Number.isFinite(this.percent);
            },
            getFormattedPercent() {
                return this.getPercent < 0 ? this.getPercent.toString().substr(1) : this.getPercent;
            },
            getPercent() {
                return Math.round(this.percent);
            },
            shouldShowReversePercentSign() {
                return this.percent_type === 'reverse' && this.getPercent !== 0;
            },
            percentReverseSignClass() {
                return this.getPercent < 0 ? 'fas fa-minus' : 'fas fa-plus';
            },
            badgeClasses() {
                let classes = [];

                if (this.percent !== null)
                    classes.push(this.percent_type === 'default' ? this.percentClassDefault : this.percentClassReverse);

                if (this.isMainValueZero)
                    classes.push('badge-value-zero');

                return classes.join(' ');
            },
            isMainValueZero() {
                return this.percent === 0 || this.seconds === 0 || this.quantity === 0;
            },
            percentClassDefault() {
                if (!this.isValidPercent)
                    return 'p-lightred';

                let p = this.getPercent;

                if (p >= 100 && p < 125) return 'p-lightred';
                if (p >= 126) return 'p-red';

                return '';
            },
            percentClassReverse() {
                if (!this.isValidPercent)
                    return 'p-lightred';

                let p = this.getPercent;

                if (p <= -25) return 'p-green';
                if (p > -25 && p < 0) return 'p-lightgreen';
                if (p > 0 && p < 25) return 'p-lightred';
                if (p >= 26) return 'p-red';

                return '';
            },
        },

    }
</script>

<style>

    .dash-badge {
        font-size: calc(10px + 0.1vw);
        display: inline-block;
        margin: 0 0 0 10px;
        padding: 1px 4px;
        background-color: #242424;
        border-radius: 4px;
        text-shadow: none;
        border: 1px solid #000;
        text-align: left;
        vertical-align: text-top;
        color: #c3c3c3;
    }

    .dash-badge-icon {
        margin-right: 3px;
        float: left;
        height: 100%;
    }

    .dash-badge-metric {
        float: left;
        height: 100%;
    }

    .dash-totals .dash-badge {
        margin: 0 auto;
        padding: 0 5px;
        background: 0;
        height: 100%;
        display: flex;
        width: 100%;
        border-radius: 0;
        border: none;
        flex-wrap: wrap;
        text-align: center;
    }

    .dash-totals .dash-badge-icon {
        font-size: 10px;
        padding: 11px 0 0 0;
        color: #bebebe;
        flex: initial;
        margin: 0;
        height: auto;
        width: 100%;
        display: flex;
    }

    .dash-totals .dash-badge-metric {
        font-size: 15px;
        color: #ededed;
        flex: 1;
        height: auto;
        width: 100%;
        font-weight: bold;
    }

    .dash-totals .dash-badge-icon .fa,
    .dash-totals .dash-badge-icon .fas {
        flex: auto;
        width: 100%;
        text-align: center;
    }

    .badge-value-zero {
        opacity: 0.3;
    }


    @media (min-width:1200px) {
        .dash-totals .dash-badge {

        }
        .dash-totals .dash-badge-icon {
            font-size: 13px;
        }
        .dash-totals .dash-badge-metric {
            font-size: calc(25px + 0.1vw);
            font-weight: normal;
        }
    }

    .p-lightgreen {
        border-color: #031102 !important;
        color: #9FC69B !important;
        background-color: #2F3E2D !important;
    }

    .p-green {
        border-color: #000 !important;
        color: #D0E9CE !important;
        background-color: #1E7213 !important;
    }

    .p-yellow {
        border-color: #959F2C !important;
        color: #3f4416 !important;
        background-color: #ECF5B3 !important;
    }

    .p-lightred {
        border-color: #120101 !important;
        color: #d8bebe !important;
        background-color: #503030 !important;
    }

    .p-red {
        border-color: #000 !important;
        color: #edd1d1 !important;
        background-color: #8D0E0E !important;
    }

</style>